import SaveWithTaskButtonDialog from "@/components/SaveWithTaskButtonDialog.tsx";
import { Box, Button, Stack } from "@mui/material";
import type { BaseSyntheticEvent, ReactNode } from "react";

type Props = {
    caseStatus: string;
    isDirty: boolean;
    handleSubmitWithTask: (
        taskId: string,
        note: string,
        caseStatus: string,
        event?: BaseSyntheticEvent,
    ) => void;
};
const SaveButton = ({ caseStatus, isDirty, handleSubmitWithTask }: Props): ReactNode => {
    return (
        <Stack
            sx={{
                flexDirection: "row",
                justifyContent: "flex-end",
            }}
        >
            <Box>
                {isDirty && (
                    <Button
                        variant="contained"
                        type={"submit"}
                        sx={{
                            p: 1,
                            borderRadius: "8px",
                            fontWeight: 800,
                            mr: 2,
                        }}
                    >
                        Save
                    </Button>
                )}
            </Box>
            {isDirty && (
                <SaveWithTaskButtonDialog
                    caseStatus={caseStatus}
                    handleSubmitWithTask={handleSubmitWithTask}
                />
            )}
        </Stack>
    );
};

export default SaveButton;
